module.exports = __webpack_public_path__ + "img/slice_delete_one_element.c56c3354.png";